exports.list = {
    path: '/proses_closing',
    name: 'proses_closing', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/proses_closing/List.vue"),
  }
  